module.exports = __webpack_public_path__ + "web/img/verify2.924eb121.jpg";